import type { FieldError, FieldErrors, FieldValues } from 'react-hook-form';

import Typography from '@mui/material/Typography';

interface Props {
  error?: FieldError | FieldErrors<FieldValues> | FieldErrors<FieldValues>[];
  /** Lets the field point to the message with `aria-describedby`. */
  id?: string;
}

export const TextError: React.FC<Props> = ({ error, id }) => {
  if (!error || Array.isArray(error)) {
    return null;
  }

  const message =
    'message' in error && typeof error.message === 'string' ? error.message : undefined;

  if (!message) {
    return null;
  }

  return (
    <Typography color="error" component="div" id={id} sx={{ pt: 1 }} variant="f12Regular">
      {message}
    </Typography>
  );
};
